import { Flex, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { dueDay, daysUntilDue } from "../../../utils/due-day";
import classes from "../list.module.css";

type Props = {
  dueDate?: string | Date | null;
  /** @deprecated Ignored — days are computed from dueDate locally. */
  remainingDays?: number | null;
  paid?: boolean;
};

export function DueCell({ dueDate, paid }: Props) {
  const { t } = useTranslation("common");
  const dash = t("list.dash");

  if (!dueDate) {
    return (
      <Text className={classes.dueDate} c="dimmed">
        {dash}
      </Text>
    );
  }

  const dateLabel = dueDay(typeof dueDate === "string" ? dueDate : dayjs(dueDate).toISOString()) ?? dash;

  if (paid) {
    return <Text className={classes.dueDate}>{dateLabel}</Text>;
  }

  const days = daysUntilDue(typeof dueDate === "string" ? dueDate : dayjs(dueDate).toISOString()) ?? 0;
  let statusNode: ReactNode = null;

  if (days < 0) {
    statusNode = (
      <Text className={classes.dueOverdue}>
        {t("list.dueOverdue", { days: Math.abs(days) })}
      </Text>
    );
  } else if (days === 0) {
    statusNode = <Text className={classes.dueMuted}>{t("list.dueToday")}</Text>;
  } else {
    statusNode = (
      <Text className={classes.dueMuted}>
        {t("list.dueRemaining", { days })}
      </Text>
    );
  }

  return (
    <Flex direction="column" gap={2}>
      <Text className={classes.dueDate}>{dateLabel}</Text>
      {statusNode}
    </Flex>
  );
}
